module.exports = __webpack_public_path__ + "static/media/audiobg.c541ac54.png";